import useDataLayer from './useDataLayer';

export default function DataLayer() {
  useDataLayer();

  return null;
}
